import "@hotwired/turbo-rails";
import "@37signals/lexxy";
import "./controllers";
import * as bootstrap from "bootstrap";

// Initialize Bootstrap tooltips after Turbo navigation (also fires on initial page load)
document.addEventListener("turbo:load", () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));
});
